{
  "overview.title": "Översikt",
  "overview.body": "Så ser dagen ut på {workshop}.",
  "overview.kpi.today": "Jobb i dag",
  "overview.kpi.today_hint": "Från midnatt till midnatt, avbokade borträknade.",
  "overview.kpi.week": "Kommande sju dagar",
  "overview.kpi.week_hint": "Allt som är inbokat framåt.",
  "overview.kpi.pending": "Väntar på svar",
  "overview.kpi.pending_hint": "Bokningar du behöver ta ställning till.",
  "overview.kpi.value": "Värde i dag",
  "overview.kpi.value_hint": "Summa för dagens jobb.",
  "overview.today.heading": "Dagens jobb",
  "overview.today.empty": "Inga bokningar i dag.",
  "overview.column.time": "Tid",
  "overview.column.customer": "Kund",
  "overview.column.service": "Tjänst",
  "overview.column.resource": "Resurs",
  "overview.column.status": "Status",
  "overview.column.value": "Värde",
  "overview.unassigned": "Ingen tilldelad",
  "overview.open_calendar": "Öppna kalendern",
  "overview.error": "Vi kunde inte hämta översikten.",
  "calendar.title": "Kalender",
  "calendar.today": "I dag",
  "calendar.previous": "Föregående",
  "calendar.next": "Nästa",
  "calendar.view.day": "Dag",
  "calendar.view.week": "Vecka",
  "calendar.view.month": "Månad",
  "calendar.new_booking": "Ny bokning",
  "calendar.create.walkin": "Drop-in",
  "calendar.create.walkin.hint": "Kunden står i verkstaden. Bokningen bekräftas direkt.",
  "calendar.create.service": "Tjänst",
  "calendar.create.service.empty": "Inga tjänster är upplagda ännu.",
  "calendar.create.when": "Tid",
  "calendar.create.date": "Datum",
  "calendar.create.resource": "Utförs av",
  "calendar.create.resource.auto": "Välj åt mig",
  "calendar.create.customer": "Kund",
  "calendar.create.name": "Namn",
  "calendar.create.email": "E-post",
  "calendar.create.email.hint": "Bekräftelsen mejlas hit. Utan e-post behövs ett telefonnummer.",
  "calendar.create.phone": "Telefon",
  "calendar.create.submit": "Skapa bokning",
  "calendar.create.saving": "Skapar …",
  "calendar.create.created": "Bokningen är skapad.",
  "calendar.create.error.service": "Välj minst en tjänst.",
  "calendar.create.error.name": "Skriv kundens namn.",
  "calendar.create.error.email": "Kontrollera e-postadressen.",
  "calendar.create.error.contact": "Vi behöver antingen en e-postadress eller ett telefonnummer.",
  "calendar.create.slots": "Lediga tider",
  "calendar.create.slots.hint": "Välj en tjänst för att se lediga tider.",
  "calendar.create.slots.empty": "Inga lediga tider den här dagen.",
  "calendar.create.slots.nearest": "Närmaste lediga tider",
  "calendar.create.slots.taken": "Den tiden är upptagen. Välj en av tiderna nedan.",
  "calendar.create.slots.none": "Fullbokat {days} dagar framåt.",
  "calendar.create.slots.error": "Kunde inte hämta lediga tider.",
  "calendar.create.slots.pick": "Välj {time}",
  "calendar.create_in_column": "Ny bokning för {resource}",
  "calendar.filter": "Filter",
  "calendar.filter.clear": "Rensa filter",
  "calendar.filter.resource": "Resurs",
  "calendar.filter.service": "Tjänst",
  "calendar.filter.status": "Status",
  "calendar.filter.all": "Alla",
  "calendar.zoom": "Radhöjd",
  "calendar.now": "Nu",
  "calendar.week_of": "Vecka {week}",
  "calendar.status.pending": "Ej bekräftad",
  "calendar.status.confirmed": "Bekräftad",
  "calendar.status.in_progress": "Pågår",
  "calendar.status.completed": "Klar",
  "calendar.status.cancelled": "Avbokad",
  "calendar.status.no_show": "Uteblev",
  "calendar.status.external": "Från Google",
  "calendar.resource.staff": "Tekniker",
  "calendar.resource.van": "Mobil enhet",
  "calendar.resource.bay": "Plats",
  "calendar.blocker.vacation": "Semester",
  "calendar.blocker.sick": "Sjuk",
  "calendar.blocker.training": "Utbildning",
  "calendar.blocker.break": "Rast",
  "calendar.blocker.closed": "Stängt",
  "calendar.blocker.blackout": "Spärrad",
  "calendar.blocker.add": "Blockera tid",
  "calendar.blocker.kind": "Anledning",
  "calendar.blocker.whole_day": "Hela dagen",
  "calendar.blocker.repeat": "Upprepa varje vecka",
  "calendar.blocker.repeat_until": "Till och med",
  "calendar.blocker.save": "Spara blockering",
  "calendar.blocker.remove": "Ta bort blockering",
  "calendar.blocker.synced": "Kommer från Google och kan inte ändras här.",
  "calendar.event.label": "{service}, {time}, {resource}, {status}",
  "calendar.event.buffer": "Förberedelsetid",
  "calendar.drag.moved": "Flyttad till {time}, {resource}",
  "calendar.drag.saved": "Sparad: {time}, {resource}",
  "calendar.drag.cancelled": "Flytten avbröts",
  "calendar.drag.hint": "Mellanslag för att flytta, piltangenter för att välja tid, Enter för att spara.",
  "calendar.empty.day": "Inga bokningar i dag. Vill du lägga till en?",
  "calendar.empty.filtered": "Inga bokningar matchar filtret.",
  "calendar.empty.no_resources": "Den här verkstaden har inga resurser än.",
  "calendar.error.load": "Vi kunde inte hämta kalendern.",
  "calendar.error.retry": "Försök igen",
  "calendar.offline": "Du är offline. Kalendern visas som den såg ut senast.",
  "calendar.stale.one": "{count} ny bokning — uppdatera",
  "calendar.stale.other": "{count} nya bokningar — uppdatera",
  "calendar.conflict.title": "Tiden är tyvärr redan bokad",
  "calendar.conflict.alternatives": "Här är tre andra tider:",
  "calendar.conflict.reverted": "Bokningen ligger kvar på sin gamla tid.",
  "calendar.unassigned.title": "Utan resurs",
  "calendar.unassigned.empty": "Alla bokningar är tilldelade.",
  "calendar.unassigned.hint": "Dra en bokning till en kolumn för att tilldela den.",
  "calendar.unassigned.assign": "Tilldela {resource}",
  "route.title": "Dagens rutt",
  "route.empty": "Inga stopp i dag.",
  "route.stop": "Stopp {index}",
  "route.travel_from_previous": "{minutes} min körning ({km} km)",
  "route.travel_from_base": "{minutes} min från verkstaden ({km} km)",
  "route.no_address": "Ingen adress angiven",
  "route.estimate_note": "Restiderna är uppskattade fågelvägen.",
  "job.title": "Jobbkort",
  "job.customer": "Kund",
  "job.object": "Objekt",
  "job.services": "Tjänster",
  "job.status": "Status",
  "job.notes": "Interna anteckningar",
  "job.notes.placeholder": "Syns bara för er på verkstaden.",
  "job.notes.save": "Spara anteckning",
  "job.notes.saved": "Anteckningen är sparad",
  "job.photos": "Bilder",
  "job.photos.before": "Före",
  "job.photos.after": "Efter",
  "job.photos.damage": "Skada",
  "job.photos.add": "Lägg till bild",
  "job.photos.empty": "Inga bilder än.",
  "job.photos.uploading": "Laddar upp …",
  "job.photos.remove": "Ta bort bild",
  "job.photos.too_large": "Bilden är för stor. Max {mb} MB.",
  "job.photos.wrong_type": "Det där verkar inte vara en bild.",
  "job.notifications": "Utskick",
  "job.notifications.empty": "Inga utskick för den här bokningen.",
  "job.total": "Totalt",
  "job.booked_at": "Bokad {when}",
  "job.source.web": "Bokad på webben",
  "job.source.phone": "Bokad per telefon",
  "job.source.walkin": "Drop-in",
  "job.source.partner": "Bokad av partner",
  "job.source.import": "Importerad bokning",
  "job.cancel": "Avboka",
  "job.cancel.reason": "Anledning",
  "job.cancel.confirm": "Avboka bokningen",
  "job.cancel.warning": "Kunden får ett mejl om att tiden är avbokad.",
  "calendar.create.drop_off": "Lämning",
  "calendar.create.ready": "Klar",
  "calendar.create.ready_invalid": "Klar måste vara minst 5 minuter efter lämning.",
  "job.times": "Tid och pris",
  "job.times.save": "Spara",
  "job.times.saved": "Sparat",
  "job.price": "Pris ({currency})"
}
